<template>
    <div>
        <MainModal 
            :show-modal="showModal" 
            size="sm" 
            footer-class="pt--0"
            :close-btn="false"
        >
            <template #body>
                <div class="grid gap-3 p-6 pb--0 px-2">
                    <div class="flex w-100 align-items-center justify-content-center">
                        <div class="rounded-full p-2 bg-error-400 w--fit">
                            <IconSvg name="error" fill="#E73B37" width="24px" height="24px" />
                        </div>
                    </div>

                    <div class="flex gap-2 flex-col align-items-center justify-content-center">
                        <p class="text--base text--semi--bold">
                            Are you sure?
                        </p>
                    </div>

                    <template v-if="!customMsg">
                        <div class="flex gap-2 flex-col align-items-center justify-content-center ">
                            <p v-if="items && items.length" class="text--sm text-gray-400 text-center">
                                {{ `Are you sure you want to delete these ${items.length} ${type}s?` }}
                            </p>
                            <p v-else class="text--sm text-gray-400 text-center">
                                {{ `Are you sure you want to delete this ${type}?` }}
                            </p>
                        </div>
                    </template>
                    <template v-else>
                        <slot name="custom-msg" />
                    </template>
                </div>
            </template>

            <template #footer>
                <slot v-if="customFooter" name="custom-footer" />
                
                <div v-else class="w-100 flex justify-content-center align-items-center gap-2 pb--10">
                    <BaseButton 
                        label="Cancel" 
                        full-width
                        class="text--sm"
                        size="sm"
                        variant="outline" 
                        variant-style="secondary"
                        @submit="$emit('cancel')"
                    />
                    <BaseButton 
                        :label="btnCTA" 
                        full-width
                        class="text--sm"
                        variant="warning" 
                        size="sm"
                        :loading="loading" 
                        @submit="$emit('delete')" 
                    />
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import BaseButton from "../buttons/BaseButton.vue";
import IconSvg from "../icons/Icon-Svg.vue";
import MainModal from "./MainModal.vue";

export default {
    name: "ConfirmDeletion",

    components: { MainModal, BaseButton, IconSvg },

    props: {
        type: {
            type: String,
            default: "",
        },
        loading: {
            type: Boolean,
            default: false,
        },
        items: {
            type: Array,
            default: () => [],
        },
        showModal: {
            type: Boolean,
            default: false,
        },
        customMsg: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        customFooter: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["cancel", "delete"],

    computed: {
        btnCTA() {
            if (this.items.length > 1) {
                return `Delete ${this.type}s`;
            }

            return `Delete ${this.type}`;
        },
    },
};
</script>